import { render } from "./tabSelection.vue?vue&type=template&id=13d546b1&scoped=true"
import script from "./tabSelection.vue?vue&type=script&lang=js"
export * from "./tabSelection.vue?vue&type=script&lang=js"

import "./tabSelection.vue?vue&type=style&index=0&id=13d546b1&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src802653185/src/macra-logistics-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13d546b1"]])

export default __exports__